/* eslint-disable */
import { Helmet } from 'react-helmet-async';
import React, { useState } from 'react';
// @mui
import { Container, Typography, Paper } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// components

// ----------------------------------------------------------------------

export default function Information() {
  const [email, setemail] = React.useState('');
  const [number, setnumber] = React.useState('');
  const [title, settitle] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <>
      <Helmet>
        <title> Information | Smartshield </title>
      </Helmet>

      <Container>
        <Typography variant="h4" sx={{ mb: 5 }}>
          Alert Detail
        </Typography>
        <Paper>
          <DialogTitle>{'Alert'}</DialogTitle>
          <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
              <Typography sx={{ width: '33%', flexShrink: 0 }}>About Alert</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container direction={'row'}>
                <Grid item container direction={'column'} xs={12}>
                  {' '}
                  <Grid item>
                    <Typography variant="caption">AlertID</Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="caption">Name</Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="caption">Type</Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="caption">Channel</Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="caption">Severity</Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="caption">Status</Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="caption">Date and Time Alert</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Paper>
        <Paper>
            
        </Paper>
      </Container>
    </>
  );
}
